// extracted by mini-css-extract-plugin
module.exports = {"Values":"ValuesBlock_Values__3LWsy","ValuesWrap":"ValuesBlock_ValuesWrap__3MdZL"};